import { api } from './instance'
import type { Workspace } from '../types'

export const workspacesApi = {
  getWorkspaces: async (includeShared = true): Promise<Workspace[]> => {
    const { data } = await api.get('/workspaces', { params: { includeShared } })
    return data
  },

  getWorkspaceById: async (id: string): Promise<Workspace> => {
    const { data } = await api.get(`/workspaces/${id}`)
    return data
  },

  createWorkspace: async (workspace: Omit<Workspace, 'id' | 'ownerId' | 'createdAt' | 'updatedAt'>): Promise<Workspace> => {
    const { data } = await api.post('/workspaces', workspace)
    return data
  },

  updateWorkspace: async (id: string, updates: Partial<Workspace>): Promise<Workspace> => {
    const { data } = await api.put(`/workspaces/${id}`, updates)
    return data
  },

  deleteWorkspace: async (id: string): Promise<void> => {
    await api.delete(`/workspaces/${id}`)
  },
}
